import React, { Component } from 'react'
import { Layout, Button } from 'antd'

import Feed from "../Feed"
import FilterPanel from '../../components/Modules/FilterPanel'
import PageHeader from "../../components/Modules/PageHeader";

import Events from "../../services/events";

import '../Feed/feed.less';

const { Content } = Layout;

export default class Channels extends Component {
  state = {
    loading: true
  };

  async componentDidMount() {
    this.setFilters()
  }

  setFilters() {
    Events.setFilter('events', 'channels');
    Events.setSort('time', 'desc')
  }

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  }

  render () {
    const { channels } = this.props.data;
    const list = (channels && Events.filterList(channels)) || [];

    return (
      <Layout className="page-wrapper">
        <Content>
          <PageHeader
            className="header"
            title="Channels"
            isHideBackButton={true}
            extra={
              <div className="search-form">
                <FilterPanel 
                  filter={this.filterBy} 
                  title="Channel search"
                  type="channel"
                  deviceType 
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="Channel search"
            mobileTypeSearch="channel"
          />
          <Feed
            list={list}
            addButtonCaption={"Add channel"}
            renderType={"channels"}
            location={this.props.location}
          />
        </Content>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Channels/index.js